import Swal from "sweetalert";
import axios from "axios";
import { io } from "socket.io-client";
import localforage from "localforage";

export const login = (data, history, setLoading) => (dispatch) => {
  setLoading(true);

  axios
    .post(`${process.env.REACT_APP_BASE_URL}/users/login`, data)
    .then((response) => {
      const resultLogin = response.data.data;
      // const url = `kalasanerp-api.lyrid.id:8000/orders`;
      // // const socket = io(url, {
      // //   query: { access_token: resultLogin.token },
      // // });
      const userLogin = { ...resultLogin, user_isAuth: true };

      setLoading(false);

      const socket = io(process.env.REACT_APP_SERVER_SOCKET, {
        reconnection: false,
      });

      socket.on("connect", () => {
        console.log("Connected to Socket.IO server frontend");
      });

      localStorage.setItem("view-mode", "desktop");
      if (resultLogin?.role?.toUpperCase() === "SUPPLIER") {
        localStorage.removeItem("show_announcement");
      } else {
        localStorage.setItem("show_announcement", "true");
      }
      socket.emit("login", resultLogin.employee_id);
      dispatch({ type: "USER_LOGIN", payload: userLogin });
      Swal("Login berhasil!", "", "success");

      // Data wajah saat login disimpan di state dan localforage
      if (resultLogin.nip && resultLogin.token) {
        axios.get(`${process.env.REACT_APP_BASE_URL}/employee/face/${resultLogin.nip}`, {
          headers: { access_token: resultLogin.token }
        }).then(res => {
          if (res?.data?.data) {
            dispatch({ type: "UPDATE_USER", payload: { face_descriptor: res.data.data } });
            localforage.setItem(`face_descriptor_${resultLogin.nip}`, res.data.data);
          }
        }).catch(err => console.error("Gagal prefetch wajah saat login", err));
      }
    })
    .catch((error) => {
      setLoading(false);
      dispatch({
        type: "EROR_LOGIN",
        payload: error?.response?.data?.message,
      });
      Swal("Login Gagal", error?.response?.data?.message || "", "error");
    });
};

export const changeOutlet = (nip, outletId) => (dispatch) => {
  const insert = {
    nip: nip,
    outlet_id: outletId,
  };

  axios
    .patch(
      `${process.env.REACT_APP_BASE_URL}/superuser/changeOutlet/${nip}`,
      insert
    )
    .then((response) => {
      const res = response.data.data;

      dispatch({
        type: "CHANGE_OUTLET",
        payload: {
          outlet_id: outletId,
          outlet: res.outlet,
          outlet_code: res.outlet_code,
        },
      });
      window.location.reload();
      Swal("Pindah outlet berhasil", "", "success");
    })
    .catch((error) => {
      Swal(error?.response?.data?.message, "", "error");
    });
};

export const logout = (history) => async (dispatch) => {
  dispatch({ type: "LOGOUT_USER" });
  
  // Hapus data wajah dari localforage saat logout
  try {
     const keys = await localforage.keys();
     for (const key of keys) {
         if (key.startsWith("face_descriptor_")) {
             await localforage.removeItem(key);
         }
     }
  } catch (e) {
     console.error("Gagal membersihkan memori wajah saat logout", e);
  }

  history.push("/login");
};
